export const HEADER_HEIGHT_DESKTOP = 300;

export const HEADER_HEIGHT_MOBILE = 150;
